/**
 * Checks if value is an integer.
 * @param value The value being checked.
 * @return True if the value is an integer, false otherwise.
 */
export function isInt(val: number): boolean {
    return Number.isInteger(val);
}
